import { render, staticRenderFns } from "./TerminalCard.vue?vue&type=template&id=bb32fc82&scoped=true&"
import script from "./TerminalCard.vue?vue&type=script&lang=js&"
export * from "./TerminalCard.vue?vue&type=script&lang=js&"
import style0 from "./TerminalCard.vue?vue&type=style&index=0&id=bb32fc82&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb32fc82",
  null
  
)

export default component.exports